<template>
  <div class="parent-password-block">
    <div class="parent-password-content">
      <div class="text-center">
        <img alt="logo" src="./../assets/img/logo-new.svg" class="logo" @click="$router.push('/')">
      </div>
      <div class="parent-password-popup">
        <div class="request-link mb-1">{{ domain }}</div>
        <p class="text-xl text-white text-bold mb-1 text-center">{{ $lang.messages.site_request.title }}</p>
        <div class="form-group">
          <label for="parentPass" class="form-label text-white">{{ $lang.messages.app.passcode.enter_passcode }}</label>
          <input id="parentPass" type="password" class="form-control -passcode" v-model="passCode" :placeholder="$lang.messages.app.passcode.enter_passcode">
        </div>
        <div v-if="showError" class="form-error">{{ $lang.messages.app.passcode.wrong_passcode }}</div>
        <div class="text-center parent-password-buttons">
          <button @click="goBack" class="btn btn-outline">{{ $lang.messages.cancel }}</button>
          <button @click="confirm" class="btn btn-main">
            {{ $lang.messages.allow }}
          </button>
          <button @click="sendRequest" class="btn btn-main"  v-if="profileAtCurrentDevice.allowKidRequestSite">
            {{ $lang.messages.site_request.sent_request }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters, mapState} from 'vuex';
import saveSetting from '../components/mixins/saveSetting'
import {getDomainFromUrl, reportEvent} from '../helpers/utils'

export default {
  name: 'Request',
  mixins: [saveSetting],
  data: function () {
    return {
      redirectUrl: this.$route.query.redirect,
      isFromDropdown: this.$route.query.dropdown,
      passCode: '',
      showError: false,
    }
  },
  computed: {
    domain: function () {
      return getDomainFromUrl(this.redirectUrl);
    },
    ...mapGetters({
      profileAtCurrentDevice: 'profileAtCurrentDevice',
      profileIdAtCurrentDevice: 'profileIdAtCurrentDevice',
    }),
    ...mapState({
      accountPassword: state => state.accountData.password,
    })
  },

  methods: {
    goBack() {
      this.isFromDropdown ? history.go(-1) : history.go(-2);
    },
    getLinkData(){
      const {origin} = new URL(this.redirectUrl);
      const icon = 'https://www.google.com/s2/favicons?sz=64&domain=' + origin
      return {
        id: Date.now(),
        title: this.domain,
        url: origin,
        icon: icon
      }
    },

    confirm() {
      if (this.accountPassword === this.passCode) {
        const link = this.getLinkData()
        const currentLinks = this.profileAtCurrentDevice.links;
        this.saveProfileSettings(this.profileIdAtCurrentDevice, {
          links: currentLinks ? currentLinks.concat(link) : [link],
        }).then(() => {
          this.$router.replace('/kid', ()=>{
            window.location = this.redirectUrl;
          })
        })
      } else {
        this.showError = true;
      }
    },

    sendRequest() {
      const link = this.getLinkData()
      const requestItem = {
        data: link.url,
        type: 'site',
      }
      reportEvent('kidsRequest', {type: 'site'});
      const currentRequests = this.profileAtCurrentDevice.requests;
      this.saveProfileSettings(this.profileIdAtCurrentDevice, {
        requests: currentRequests ? currentRequests.concat(requestItem) : [requestItem],
      }).then(() => {
        this.goBack();
      })
    },
  },
}
</script>

<style lang="scss">


</style>
